import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrderTrakingModel, ResultFraudAnalysis } from '../model/order-blocked.model';
import { OrderBlockedServiceRest } from './order-blocked.service-rest';

@Injectable()
export class OrderBlockedService {
  constructor(private serviceRest: OrderBlockedServiceRest) { }

  getOrderBlocked(param: string, page: number, dailyPurchaseLimitExceeded: string): Observable<OrderTrakingModel> {
    return this.serviceRest.getOrderBlocked(param, page, dailyPurchaseLimitExceeded);
  }

  putResultFraudAnalysis(orderId: string, purchaseLimit: string): Observable<ResultFraudAnalysis> {
    return this.serviceRest.putResultFraudAnalysis(orderId, purchaseLimit);
  }
}
